module.exports = __webpack_public_path__ + "img/60_10.21eaf0dd.png";